module.exports = __webpack_public_path__ + "98b8e39eeca308eee9d2e235fdc7dc97.MP3";